// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AdjustFareFormRoot from "./AdjustFareFormRoot.bs.js";
import * as AdjustFareDetailsSection from "../fare-details/AdjustFareDetailsSection.bs.js";

function AdjustFareDashboard(Props) {
  var currency_symbol = Props.currency_symbol;
  var current_fare_details = Props.current_fare_details;
  var new_fare_details = Props.new_fare_details;
  var state = Props.state;
  var dispatch = Props.dispatch;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "c-adjust-fare-form-wrapper"
                }, React.createElement(AdjustFareFormRoot.make, {
                      currency_symbol: currency_symbol,
                      new_fare_details: new_fare_details,
                      state: state,
                      dispatch: dispatch
                    })), React.createElement("div", {
                  className: "c-adjust-fare-details-wrapper"
                }, React.createElement(AdjustFareDetailsSection.make, {
                      currency_symbol: currency_symbol,
                      current_fare_details: current_fare_details,
                      new_fare_details: new_fare_details,
                      state: state,
                      dispatch: dispatch
                    })));
}

var make = AdjustFareDashboard;

export {
  make ,
  
}
/* react Not a pure module */
